import { BlockNavigationIfChange } from '../../models/block-navigation-if-change';
import { MatDialog } from '@angular/material/dialog';
import { Observable, of, tap } from 'rxjs';
import { ModalComponent } from '../../../shared/components/modal/modal.component';
import { inject, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class BlockNavigationIfChangeGuard {
    private readonly dialog = inject(MatDialog);

    canDeactivate(
        component: BlockNavigationIfChange,
    ): Observable<boolean> | boolean {
        if (component.hasChanges) {
            const dialogRef = this.dialog.open(ModalComponent, {
                disableClose: true,
                data: {
                    title: 'Warning: If you leave this page now, unsaved changes will be lost.',
                    content: 'Are you sure you want to leave?',
                    primaryAction: {
                        title: 'Exit',
                        action: () => dialogRef.close(true),
                    },
                },
            });

            return dialogRef.afterClosed().pipe(
                tap((result) => {
                    // If user confirmed they want to exit, set hasChanges to false
                    // to prevent duplicate dialogs if the guard is called again
                    // (i.e. navigating from Existing Frn Filing Type to New Frn Filing via side nav)
                    if (result === true) {
                        component.hasChanges = false;
                    }
                }),
            );
        } else {
            return of(true);
        }
    }
}
